export const options = [
  {
    name: 'Sydney (+10h)',
    value: 'Australia/Sydney',
  },
  {
    name: 'Melbourne (+10h)',
    value: 'Australia/Melbourne',
  },
  {
    name: 'Brisbane (+10h)',
    value: 'Australia/Brisbane',
  },
  {
    name: 'Perth (+8h)',
    value: 'Australia/Perth',
  },
  {
    name: 'Adelaide (+9:30h)',
    value: 'Australia/Adelaide',
  },
  {
    name: 'Darwin (+9:30h)',
    value: 'Australia/Darwin',
  },
  {
    name: 'Eucla (+8:45h)',
    value: 'Australia/Eucla',
  },
  {
    name: 'Lord Howe Island (+10:30h)',
    value: 'Australia/Lord_Howe',
  },
]

import React from 'react'
import { Field } from 'redux-form'
import { vRequired } from 'components/Input/Input.validations'
import SelectPretty from 'components/Input/SelectPretty'

export default () => (
  <Field
    name="timezone"
    label="Timezone"
    component={SelectPretty}
    options={options}
    validate={[vRequired]}
  />
)



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/components/TimezoneField/TimezoneField.jsx